import { defineMessages } from 'react-intl';
import { toCityId, toDistrictId } from 'components/LocationFormSection/messages';

export const scope = 'app.containers.LandingPage.DistributionLocationPage';

export { toCityId, toDistrictId };

export default defineMessages({
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Địa điểm phân phối',
  },
  address: {
    id: `${scope}.address`,
    defaultMessage: 'Địa chỉ',
  },
  city: {
    id: `${scope}.city`,
    defaultMessage: 'Thành phố',
  },
  district: {
    id: `${scope}.district`,
    defaultMessage: 'Quận',
  },
  branch: {
    id: `${scope}.branch`,
    defaultMessage: 'Chi nhánh',
  },
  others: {
    id: `${scope}.others`,
    defaultMessage: 'Khác',
  },
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Tìm địa điểm phân phối các sản phẩm Kamereo gần bạn',
  },
  closestPosition: {
    id: `${scope}.closestLocation`,
    defaultMessage: 'Vị trí gần nhất',
  },
  getDirection: {
    id: `${scope}.getDirection`,
    defaultMessage: 'Chỉ đường',
  },
  notFound: {
    id: `${scope}.notFound`,
    defaultMessage: 'Không có kết quả',
  },
  closeTime: {
    id: `${scope}.closeTime`,
    defaultMessage: 'Đóng cửa',
  },
  openTime: {
    id: `${scope}.openTime`,
    defaultMessage: 'Mở cửa',
  },
  tel: {
    id: `${scope}.tel`,
    defaultMessage: 'Số điện thoại',
  },
});
